import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { GridField, withContext } from 'ddiForm'
import { formatDateFields, getField } from 'utils'
import { headerStyle } from 'pages/ProductSerialNumberInquiry/utils'
import NotesCheckbox from 'pages/ProductMaster/components/NotesCheckbox'
import OpenScreenLinkCell from 'pages/ProductMaster/components/OpenScreenLinkCell'
import { DynamicGridDataTooltip } from 'hoc'
import { setSelectedSerialNumber } from 'pages/ProductSerialNumberInquiry/actions'
import memoize from 'memoize-one'

import SerialNumberGridCell from 'pages/ProductSerialNumberInquiry/components/SerialNumberGridCell'

export const getRowNodeId = data => {
  const { dataId, invoiceId, orderNumber } = data
  return `${dataId} - ${invoiceId} - ${orderNumber}`
}

const dynamicColDefs = memoize(form => {
  const colDefs = [
    {
      cellRendererFramework: SerialNumberGridCell,
      cellRendererParams: {
        form
      },
      field: 'dataId',
      headerName: 'Serial No'
    },
    {
      cellRendererFramework: DynamicGridDataTooltip({
        dataField: 'notes'
      })(NotesCheckbox),
      cellRendererParams: {
        form,
        propertyName: 'salesHistory'
      },
      field: 'notes',
      headerClass: 'text-center',
      headerName: 'Notes'
    },
    {
      field: 'customerName',
      headerName: 'Customer Name'
    },
    {
      cellRendererFramework: OpenScreenLinkCell,
      cellRendererParams: {
        form,
        hasLink: true
      },
      field: 'orderNumber',
      headerName: 'Order No'
    },
    {
      cellStyle: { textAlign: 'center' },
      field: 'orderDate',
      headerClass: 'text-center',
      headerName: 'Order Date',
      valueFormatter: formatDateFields
    },
    {
      cellStyle: { textAlign: 'center' },
      field: 'shipDate',
      headerClass: 'text-center',
      headerName: 'Ship Date',
      valueFormatter: formatDateFields
    },
    {
      cellRendererFramework: OpenScreenLinkCell,
      cellRendererParams: {
        form,
        hasLink: true
      },
      field: 'invoiceId',
      headerName: 'Invoice No'
    },
    {
      cellStyle: { textAlign: 'center' },
      field: 'invoiceDate',
      headerClass: 'text-center',
      headerName: 'Invoice Date',
      valueFormatter: formatDateFields
    },
    {
      field: 'customerPO',
      headerName: 'Customer P/O'
    },
    {
      field: 'branchId',
      headerName: 'Branch'
    },
    {
      field: 'salesmanId',
      headerName: 'Salesman'
    },
    {
      field: 'writer',
      headerName: 'Writer'
    },
    {
      field: 'shipViaId',
      headerName: 'Ship Via'
    }
  ]
  return colDefs
})

export class SalesHistory extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    form: PropTypes.string.isRequired,
    height: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
      .isRequired,
    selectedSerialNumber: PropTypes.string
  }

  static defaultProps = {
    selectedSerialNumber: ''
  }

  componentDidUpdate(prevProps, prevState) {
    const { selectedSerialNumber } = this.props
    if (prevProps.selectedSerialNumber !== selectedSerialNumber) {
      if (this.gridApi) {
        this.gridApi.onFilterChanged()
      }
    }
  }

  onGridReady = ({ api }) => {
    this.gridApi = api
  }

  onRowDoubleClicked = params => {
    const { dispatch, form } = this.props
    const value = params.data && params.data.dataId ? params.data.dataId : ''

    dispatch(setSelectedSerialNumber(form, { value }))
  }

  doesExternalFilterPass = node => {
    const { selectedSerialNumber } = this.props
    const { dataId } = node.data

    return selectedSerialNumber === dataId
  }

  isExternalFilterPresent = () => {
    const { selectedSerialNumber } = this.props

    return selectedSerialNumber !== ''
  }

  render() {
    const { form, height } = this.props

    return (
      <div className="product-serial-number-inquiry-layout-flex">
        <div className="flex-wrapper">
          <GridField
            propertyName="salesHistory"
            title="Sales History"
            getRowNodeId={getRowNodeId}
            columnDefs={dynamicColDefs(form)}
            isExternalFilterPresent={this.isExternalFilterPresent}
            doesExternalFilterPass={this.doesExternalFilterPass}
            fullWidth
            height={height}
            headerStyle={headerStyle}
            rowSelection="single"
            onGridReady={this.onGridReady}
            onRowDoubleClicked={this.onRowDoubleClicked}
          />
        </div>
      </div>
    )
  }
}

export const contextObj = {
  selectedSerialNumber: form => getField(form, 'selectedSerialNumber', '')
}

export default withContext(contextObj)(SalesHistory)
